<!-- [ngClass.gt-lg]="'gt-lg'" [ngClass.lt-lg]="'lt-lg'" [ngClass.lt-sm]="'lt-sm'" -->
<div class="grid-layout mt-section" #gridLayout >
  <ng-template ngFor let-slide [ngForOf]="slides" let-i="index">
    <div class="grid-item" [ngClass]="{'span-full': i == 0}" *ngIf="i < totalShow">
      <div class="photo" (click)="open(content, i)" [ngStyle]="{'background-image': 'url(&quot;' + slide.src + '&quot;)'}">
        <span class="show-more" *ngIf="i === (totalShow-1)">+ {{slides.length - totalShow }} photos</span>
      </div>
    </div>
  </ng-template>
</div>


<ng-template #content let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="modal-basic-title">{{currentSlide + 1 }} / {{slides.length}}</h5>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
    <div class="image-slide" fxLayout="row" fxLayoutAlign="space-between center"
      fxLayoutGap="20px">
      <div class="control left" fxFlex="50px">
        <div class="control-button" (click)="prev()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-left-fill" viewBox="0 0 16 16">
            <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"/>
          </svg>
        </div>
      </div>
      <div fxFlex>
        <img [src]="slides[currentSlide].src" />
      </div>
      <div class="control right" fxFlex="50px">
        <div class="control-button" (click)="next()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
          </svg>
        </div>
      </div>
    </div>
	</div>
</ng-template>